import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface SubscriptionData {
  sso_enabled: boolean;
  config_hashing: boolean;
  inventory_type?: "cloud_resources" | "on_prem_assets"; // optional
  deployment_type: string;
  subscription_type: string;
  all_functionalities: boolean;
  on_prem_assets_limit: number;
  cloud_resources_limit: number;
  device_count: number;
  unique_devices: boolean;
  data_retention: number;
}

export interface AuthState {
  token: string | null;
  userId: string | null;
  userData: any;
  permission: any;
  assetsData: any;
  assetsName: any;
  tempAssetName: any;
  subscriptionData: SubscriptionData | null; // 👈 typed
}

const initialState: AuthState = {
  token: null,
  userId: null,
  userData: null,
  permission: null,
  assetsData: null,
  assetsName: null,
  tempAssetName: null,
  subscriptionData: null,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    login(state, action) {
      state.token = action.payload.token;
      state.userId = action.payload.userId;
      state.assetsData = action.payload.assetsData;
      state.assetsName = action.payload.assetsName;
      state.tempAssetName = action.payload.tempAssetName;
    },
    permission(state, action: PayloadAction<any>) {
      state.permission = action.payload;
    },
    setAssetsData(state, action: PayloadAction<{ tempAssetName: any }>) {
      state.tempAssetName = action.payload.tempAssetName;
    },
    logout(state) {
      state.token = null;
      state.userId = null;
    },
    userData(state, action: PayloadAction<any>) {
      state.userData = action.payload;
    },
    subscriptionData(state, action: PayloadAction<SubscriptionData>) {
      state.subscriptionData = action.payload;
    },
    updateAssetsList(state, action) {
      state.assetsData = action.payload;
    },
  },
});

export const authActions = authSlice.actions;
export default authSlice.reducer;
